import { useState } from 'react';

export const useSwapModal = () => {
	const [showSwapModal, setShowSwapModal] = useState(false);
	const [activeSwaps, setActiveSwaps] = useState([]);
	const [activeSwapIndex, setActiveSwapIndex] = useState(false);
	const [currentCarouselSlide, setCurrentCarouselSlide] = useState(0);

	const openModal = (swaps, index) => {
		setActiveSwaps(swaps);
		setActiveSwapIndex(index);
		setCurrentCarouselSlide(0);
		setShowSwapModal(true);
	};

	const closeModal = () => {
		setShowSwapModal(false);
		setCurrentCarouselSlide(0);
	};

	const nextSlide = () => {
		if (currentCarouselSlide < activeSwaps.length - 1) {
			setCurrentCarouselSlide(currentCarouselSlide + 1);
		}
	};

	const previousSlide = () => {
		if (currentCarouselSlide > 0) {
			setCurrentCarouselSlide(currentCarouselSlide - 1);
		}
	};

	const goToSlide = (index) => {
		setCurrentCarouselSlide(index);
	};

	return {
		showSwapModal,
		activeSwaps,
		activeSwapIndex,
		currentCarouselSlide,
		openModal,
		closeModal,
		nextSlide,
		previousSlide,
		goToSlide,
	};
};
